import { configureStore } from "@reduxjs/toolkit";
import { myreducer } from "./reducer/reducer";
import { loginApi } from "./api/Login";
import dashboardApi from "./api/DashboardApi";
import leadApi from "./api/LeadApi";
import followupApi from "./api/FollwupApi";

export const store = configureStore({
  reducer: {
    myreducer: myreducer.reducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [leadApi.reducerPath]: leadApi.reducer,
    [followupApi.reducerPath]: followupApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      [loginApi.middleware],
      [dashboardApi.middleware],
      [leadApi.middleware],
      [followupApi.middleware]
    ),
});
